import { Button } from '@venusprotocol/ui';
import type { Address } from 'viem';
import { useDisconnect } from 'wagmi';

import { Icon } from 'components';
import { AccountOverview } from 'containers/AccountOverview';
import { CopyAddressButton } from 'containers/CopyAddressButton';
import { VipTelegramGroupButton } from 'containers/VipTelegramGroupButton';
import { useTranslation } from 'libs/translations';
import { ClaimRewardsButton } from '../../ClaimRewardsButton';
import { Settings } from '../../Settings';
import { UserButton } from '../UserButton';

export interface AccountModalProps {
  address: Address;
  isVip: boolean;
  isPrime: boolean;
}

export const AccountModal: React.FC<AccountModalProps> = ({ address, isVip, isPrime }) => {
  const { disconnect } = useDisconnect();
  const handleDisconnect = () => disconnect();

  const { t } = useTranslation();

  return (
    <div className="p-6 flex flex-col gap-y-6 sm:w-123">
      <div className="flex flex-col gap-y-3">
        <div className="flex items-center gap-x-3">
          <UserButton
            address={address}
            isVip={isVip}
            isPrime={isPrime}
            disabled
            className="w-full h-12"
          />

          <CopyAddressButton className="shrink-0 text-light-grey" address={address} />
        </div>

        <ClaimRewardsButton className="h-12 bg-dark-blue-active sm:hidden" />
      </div>

      <AccountOverview accountAddress={address} showGraph={false} />

      <Settings />

      <div className="flex flex-col gap-y-3">
        <VipTelegramGroupButton />

        <Button variant="secondary" onClick={handleDisconnect} className="w-full">
          <div className="flex items-center gap-x-2">
            <Icon name="connect" className="size-5 text-inherit transition-colors" />

            <span>{t('accountModal.disconnectButtonLabel')}</span>
          </div>
        </Button>
      </div>
    </div>
  );
};
